import ProductListingPage from "../components/ProductListing";

const ProductosPage: React.FC = () => {
    return <ProductListingPage mode="all-products" />;
};

export default ProductosPage;
